// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__DwmHV","rotate":"Spinner_rotate__deNLh","prixClipFix":"Spinner_prixClipFix__vESo9","container":"Spinner_container__LKJI8"};